import { RefObject, useEffect, useState } from 'react';
import { throttle } from 'lodash';

export default function useScrollEndReached(ref: RefObject<HTMLElement>) {
  const [hasEndReached, setHasEndReached] = useState(false);
  const onScroll = throttle(() => {
    if (!ref.current) {
      setHasEndReached(false);
      return;
    }
    const top = ref.current.getBoundingClientRect().top;
    setHasEndReached(top + 0 >= 0 && top - 0 <= window.innerHeight);
  }, 100);

  useEffect(() => {
    document.addEventListener('scroll', onScroll, true);
    return () => document.removeEventListener('scroll', onScroll, true);
  });

  return hasEndReached;
}
